import { Toast } from 'src/common/components/ToastManager/types'
import { atom } from 'jotai'

export const toastsAtom = atom<Toast[]>([])
export const nextIdAtom = atom(1)
